export default __webpack_public_path__ + "static/media/legend-layer.c29f1930.png";